<template>
  <div>
    <a-row :gutter="24">
      <a-col :span="24">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="是否缴纳保证金" prop="hasPayBond">
              <a-radio-group v-model="form.hasPayBond" :disabled="!isEditable">
                <a-radio :value="1">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>

          <a-col
            :span="12"
            v-if="form.hasPayBond == 1 && form.hasPriorityLease == 1"
          >
            <a-form-model-item
              label="优先承租权人交纳保证金"
              prop="hasPayBondByPriorityHolder"
            >
              <a-radio-group v-model="form.hasPayBondByPriorityHolder" :disabled="!isEditable">
                <a-radio :value="1">足额保证金</a-radio>
                <a-radio :value="2">差额保证金</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-col>

      <a-col :span="24" v-if="form.hasPayBond == 1">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="保证金金额" prop="bondAmount">
              <a-input
                v-model="form.bondAmount"
                placeholder="请输入保证金金额"
                suffix="元"
                :disabled="!isEditable"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item
              label="保证金缴纳截止时间"
              prop="bondPayDeadlineType"
            >
              <a-radio-group v-model="form.bondPayDeadlineType" disabled>
                <a-radio :value="2">招租公告截止日前交纳</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-col>

      <a-col :span="24" v-if="form.hasPayBondByPriorityHolder == 2">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item
              label="差额保证金金额"
              prop="bondAmountByPriorityHolder"
              extra="差额保证金仅涉及优先承租权人参与承租，并已向出租方交纳过租赁押金的"
            >
              <a-input
                v-model="form.bondAmountByPriorityHolder"
                placeholder="请输入差额保证金金额"
                suffix="元"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-col>

      <a-col :span="24">
        <a-form-model-item label="保证金事项">
          <div>
            <template v-if="form.hasPayBond == 0"
              >交纳金额：保证金金额 0 元</template
            >
            <template v-else>
              <template
                v-if="
                  form.hasPayBond == 1 && form.hasPayBondByPriorityHolder == 1
                "
                >1.交纳金额：保证金金额<span style="color: red">
                  {{ form.bondAmount }} </span
                >元 <br
              /></template>
              <template
                v-if="
                  form.hasPayBond == 1 && form.hasPayBondByPriorityHolder == 2
                "
                >1.交纳金额：保证金金额<span style="color: red">
                  {{ form.bondAmount }}
                </span>
                元 ，优先承租权人差额保证金金额<span style="color: red">
                  {{ form.bondAmountByPriorityHolder }} </span
                >元。<br
              /></template>
              2.交纳时间：招租公告起始日至招租公告截止日前交纳至租赁平台指定银行账户，实际以租赁平台到账时间为准。意向承租方逾期未交纳保证金的，视为放弃意向承租资格。
              <br />
              3.交纳方式：线上交纳
              <a style="color: #1890ff" @click="showAccount()"
                >保证金收款银行及账号</a
              >
              <br />
              4.返还方式：
              （1）意向承租方被确定为承租方且不存在违规违约情形的，其交纳的保证金在租赁平台出具租赁凭证后全额返还；
              （2）意向承租方未被确定为承租方，且未出现《上海交易集团有限公司不动产租赁平台保证金操作指引》所列责任赔偿情形的，应在承租方被确定后3
              个工作日内将其已交纳的保证金返还；
              （3）意向承租方已交纳保证金，未被出租方确认承租资格的，租赁平台在收到出租方书面意见之日起3
              个工作日内，将意向承租方交纳的保证金返还；
              （4）租赁平台应当在作出招租中止或终结决定之日起
              3个工作日内，将不涉及公开招租活动中止或终结事项的意向承租方交纳的保证金返还；
              （5）出租底价以价格区间方式公示的，意向承租方在查看出租底价后放弃承租的，租赁平台在收到意向承租方退出申请之日起3
              个工作日内，将其已交纳的保证金返还。<br />
              5.为保护租赁各方合法利益，出租方在此做出特别提示，意向承租方一旦提交有效材料经租赁平台确认，且已经交纳保证金的，即获得竞价或择优遴选资格，意向承租方需遵守租赁平台关于保证金的相关规则，其对如下内容作出承诺：如意向承租方存在以下任何一种情形，出租方可依法依规向意向方主张相应的赔偿责任，租赁平台将按照保证金相关规则处理。
              （1）意向承租方提供虚假、失实、无效或不完整材料造成出租方损失的；
              （2）意向承租方利用获取的商业秘密，侵害出租方合法权益的；
              （3）意向承租方之间相互串通，影响公平竞争，侵害出租方合法权益的；
              （4）意向承租方违反法律法规或相关规定给出租方造成损失的。
            </template>
          </div>
        </a-form-model-item>
      </a-col>

      <a-col :span="24" v-if="form.hasPayBond == 1">
        <a-form-model-item label="保证金事项其他说明" prop="otherBondDesc">
          <a-textarea
            placeholder="请输入保证金事项其他说明"
            v-model="form.otherBondDesc"
            :rows="1"
            :disabled="!isEditable"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
    <!-- 新增/编辑弹窗 -->
    <a-modal
      :visible="visible"
      :footer="null"
      width="600px"
      @cancel="closeModule"
      destroyOnClose
    >
      <h2 class="title">保证金收款账户信息</h2>
      <div class="account-wrapper">
        <div class="info-row">
          <div class="left">
            <span class="label">账户名称：</span>
            <span class="value">上海交易集团有限公司</span>
            <span class="copy" @click="copyText('上海交易集团有限公司')">复制</span>
          </div>
        </div>

        <div class="info-row">
          <div class="left">
            <span class="label">开户银行名称：</span>
            <span class="value">上海农村商业银行股份有限公司营业部</span>
            <span class="copy" @click="copyText('上海农村商业银行股份有限公司营业部')">复制</span>
          </div>
        </div>

        <div class="info-row">
          <div class="left">
            <span class="label">账户：</span>
            <span class="value">50131000973023187</span>
            <span class="copy" @click="copyText('50131000973023187')">复制</span>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      visible: false,
      accountData: [],
    };
  },
  methods: {
    showAccount() {
      this.visible = true;
    },
    closeModule() {
      this.visible = false;
    },
    copyText(text) {
      // 优先使用现代 API

      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message.open({
            content: (
              <div style="display:flex;align-items:center;">
                <a-icon
                  type="check-circle"
                  style="margin-right:6px;color:#52c41a"
                />
                复制成功
              </div>
            ),
          });
        })
        .catch(() => {
          this.$message.open({
            content: (
              <div style="display:flex;align-items:center;">
                <a-icon type="close-circle" style="margin-right:6px;color:#ff4d4f;" />
                复制失败，请手动复制
              </div>
            ),
          });
        });
    },
  },
};
</script>

<style>
.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.account-wrapper {
  padding: 12px 10px;
  width: 100%;
}

.info-row {
  margin: 0 auto 12px; /* 水平居中 + 行距 */
  text-align: center; /* 文字居中 */
  font-size: 14px;
}

.left {
  display: inline-block; /* 让它按内容宽度参与居中 */
}

.label {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.75);
}

.value {
  font-weight: 600;
  margin-left: 6px;
  color: rgba(0, 0, 0, 0.75);
}

.copy {
  font-weight: 600;
  margin-left: 10px;
  color: #1890ff;
  cursor: pointer;
}

.copy:hover {
  color: #0d6fca;
}
</style>